import React from 'react';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';
import { BrowserRouter } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';

import { StatsLeaders } from '../components/stats-leaders';

export const StatsLeadersProvider = ( { store } ) => (
    <ErrorBoundary fallback={ <></> } >
        <Provider store={ store }>
            <BrowserRouter>
                <StatsLeaders />
            </BrowserRouter>
        </Provider>
    </ErrorBoundary>
);

StatsLeadersProvider.propTypes = {
    store: PropTypes.object.isRequired
};